import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllMemoriesComponent } from './all-memories/all-memories.component';
import { MemoriesComponent } from './memories/memories.component';
import { AllProfileMemoryComponent } from './all-profile-memory/all-profile-memory.component';
import { DefaultLayoutComponent } from 'src/app/containers';
import { BreadcrumbComponent, BreadcrumbItemComponent } from '@coreui/angular';

const routes: Routes = [ 
  {
    path: '',
    data: {
      title: 'Memories'
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'memories'
      },
      {
        path: 'memories',
        component: MemoriesComponent,
        data: {
          title: 'Memories'
        }
      },    
    ]
  },

]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MemoriesRoutingModule { }
